module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("ブラウザの設定により"), _c('wbr'), _vm._v("データの保存が"), _c('wbr'), _vm._v("無効化されています")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("プライベートブラウズ状態でページが表示されている、もしくはブラウザのストレージ設定が無効化されているためデータの保存ができません。"), _c('br'), _vm._v("\n    プライベートブラウズ状態を解除して頂くか、お使いのブラウザごとに以下の手順をお試しください。")]), _vm._v(" "), _c('my-howtocookie')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb1d886","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogStorageDisabledError.vue
// module id = 471
// module chunks = 1